import React from 'react';

export const Planned = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--planned';
  color = color || '#0076CC';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <g clipPath="url(#clip0_13381_1404)">
        <path
          d="M3.5 4.5625C3.5 4.28071 3.61194 4.01046 3.8112 3.8112C4.01046 3.61194 4.28071 3.5 4.5625 3.5H19.4375C19.7193 3.5 19.9895 3.61194 20.1888 3.8112C20.3881 4.01046 20.5 4.28071 20.5 4.5625V19.4375C20.5 19.7193 20.3881 19.9895 20.1888 20.1888C19.9895 20.3881 19.7193 20.5 19.4375 20.5H4.5625C4.28071 20.5 4.01046 20.3881 3.8112 20.1888C3.61194 19.9895 3.5 19.7193 3.5 19.4375V4.5625Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 7.75H20.5"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 3.5V7.75"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.34375 14.6562L10.9375 16.25L14.125 13.0625"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13381_1404">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Planned;
